import type { ApiClientWithAuth } from '@/libs/api/base/api.types.ts'
import { defineStore } from 'pinia'
import { useInsuranceApiClientImpl } from '@/client/insurance-client-impl.ts'
import { useConnectApiClientImpl } from '@/client/connect-client-impl.ts'

export const useAuthStore = defineStore('auth', () => {
  const apiClients: Array<ApiClientWithAuth> = [
    useConnectApiClientImpl(),
    useInsuranceApiClientImpl()
  ]

  const isAuthenticated = () => apiClients.every((client) => client.getIsAuthenticated())

  async function authenticate(): Promise<boolean | PromiseRejectedResult[]> {
    const authRequests = apiClients.map((client) => client.authenticate())

    const results = await Promise.allSettled(authRequests)
    const failures = results.filter((result) => result.status === 'rejected')

    if (failures.length > 0) {
      return failures
    } else {
      return true
    }
  }

  return { authenticate, isAuthenticated }
})
